import {
  FETCH_SECTION_LIST,
  SET_ARTICLE_LIST,
  SET_SECTION_DETAILS,
  SEARCH_ARTICLE,
  FETCH_TICKET_LIST,
  SET_TICKET_DETAILS,
  SET_AUTHOR_ID,
  SET_TICKET_LIST_RELOAD,
  SET_DEVICETYPE,
  SET_USERID,
  SET_USERIDv2,
  SET_NAME,
  SET_EMAIL,
  SET_CITY,
  SET_CATEGORYID,
  SET_GUESTID,
} from "../actions/types";

const initalPlayoData = {
  headerTitle: "",
  headerDescription: "",
  helpData: {
    next_page: null,
    sections: [],
    curr_page: 1,
  },
  supportData: {
    next_page: null,
    tickets: [],
    curr_page: 1,
  },
  displayError: false,
  articlesListData: {
    articlesListArray: [],
    curr_page: 1,
    page_count: null,
    sectionsNumber: null,
  },
  searchResults: {
    searchResultArray: [],
    searchKeyword: "",
    next_page: null,
    curr_page: 1,
  },
  newTicketAdded: true,
  authorId: null,
  ticketStatus: true,
  deviceType: 11,
  userId: null,
  userIdv2: null,
  guestId: null,
  name: "",
  fName: "",
  lName: "",
  email: "",
  city: "",
  categoryId: 360000495093,
  mobile: "",
  helpTS: "",
};

const playoReducer = (state = initalPlayoData, action) => {
  switch (action.type) {
    case FETCH_SECTION_LIST:
      state = {
        ...state,
        helpData: action.payload,
      };
      break;
    case SET_ARTICLE_LIST:
      state = {
        ...state,
        articlesListData: action.payload,
      };
      break;
    case SET_SECTION_DETAILS:
      state = {
        ...state,
        headerTitle: action.payload.title,
        headerDescription: action.payload.description,
      };
      break;
    case SEARCH_ARTICLE:
      state = {
        ...state,
        searchResults: action.payload,
      };
      break;
    case FETCH_TICKET_LIST:
      state = {
        ...state,
        supportData: action.payload,
        newTicketAdded: false,
      };
      break;
    case SET_TICKET_DETAILS:
      state = {
        ...state,
        headerTitle: action.payload.title,
        headerDescription: "",
        ticketStatus: action.payload.status,
      };
      break;
    case SET_AUTHOR_ID:
      state = {
        ...state,
        authorId: action.payload,
      };
      break;
    case SET_TICKET_LIST_RELOAD:
      state = {
        ...state,
        newTicketAdded: action.payload,
      };
      break;
    case SET_DEVICETYPE:
      state = {
        ...state,
        deviceType: action.payload,
      };
      break;
    case SET_USERID:
      state = {
        ...state,
        userId: action.payload,
      };
      break;
    case SET_USERIDv2:
      state = {
        ...state,
        userIdv2: action.payload,
      };
      break;
    case SET_GUESTID:
      state = {
        ...state,
        guestId: action.payload,
      };
      break;

    case SET_CATEGORYID:
      state = {
        ...state,
        categoryId: action.payload,
      };
      break;
    case SET_NAME:
      state = {
        ...state,
        ...action.payload,
      };
      break;
    case SET_EMAIL:
      state = {
        ...state,
        email: action.payload,
      };
      break;
    case SET_CITY:
      state = {
        ...state,
        city: action.payload,
      };
      break;
    case "SET_MOBILE":
      state = {
        ...state,
        ...action.payload,
      };
      break;
    case "UPDATE_HELPTS":
      state = {
        ...state,
        helpTS: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
};

export default playoReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js